import styled from '@emotion/styled';
import { Typography, Box } from '@mui/material/';
import { DISABLED, MUI_PRIMARY_MAIN } from '../../themes/tokens';
import { DatePicker } from '@mui/x-date-pickers';
import { Stack } from '@mui/material';
import { css } from '@emotion/react';

export const StyledNotes = styled(Typography)`
  max-width: 200px;
  text-overflow: ellipsis;
  overflow: auto;
  color: ${DISABLED};
  cursor: pointer;
  overflow-wrap: break-word;
`;

export const PreviewTitleBox = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  > svg {
    font-size: 32px;
    color: ${MUI_PRIMARY_MAIN};
  }
`;

export const StyledDatePicker = styled(DatePicker)<{ isError?: boolean }>`
  ${({ isError }) =>
    !isError
      ? css`
          .MuiInputBase-root::before,
          .Mui-disabled::before {
            border: none !important;
          }
        `
      : css`
          .MuiButtonBase-root.MuiIconButton-root {
            color: #d32f2f;
          }
        `}
`;

export const StyledNoticeStack = styled(Stack)`
  justify-content: space-between;
  width: 220px;

  > span:not(style) {
    margin-top: 0;
  }
`;

export const StyledTypeCell = styled(Typography)`
  font-weight: bold;
  white-space: nowrap;
`;

export const StyledLink = styled.a`
  color: inherit;
`;
